import { forwardRef } from 'react'
import { IconProps } from '../Types'

export const MarkPosted = forwardRef<SVGSVGElement, IconProps>(({ size = 32 }, forwardedRef) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 37 36"
      fill="none"
      ref={forwardedRef}
    >
      <g filter="url(#filter0_d_2527_6693)">
        <path
          d="M11.7847 28.1758L8.46591 20.0218L29.8561 3.27262L12.2256 22.6664L11.7847 28.1758Z"
          fill="white"
          fillOpacity="0.8"
          shapeRendering="crispEdges"
        />
      </g>
      <g filter="url(#filter1_d_2527_6693)">
        <path
          d="M8.46586 20.0215L4.00386 17.0404C3.35612 16.6076 3.43007 15.6331 4.13572 15.3031L29.856 3.27261L8.46586 20.0215Z"
          fill="white"
          fillOpacity="0.8"
          shapeRendering="crispEdges"
        />
      </g>
      <g filter="url(#filter2_d_2527_6693)">
        <path
          d="M11.7847 28.1756L12.2255 22.6662L29.8561 3.05201L11.7847 28.1756Z"
          fill="white"
          fillOpacity="0.8"
          shapeRendering="crispEdges"
        />
      </g>
      <g filter="url(#filter3_d_2527_6693)">
        <path
          d="M12.2255 22.6662L20.3679 28.4823C20.9189 28.8758 21.6935 28.6195 21.901 27.9751L29.856 3.2726L12.2255 22.6662Z"
          fill="white"
          fillOpacity="0.8"
          shapeRendering="crispEdges"
        />
      </g>
      <g filter="url(#filter4_d_2527_6693)">
        <path
          d="M24.6 14.3999L25.7482 15.4884L27.1994 14.8582L27.906 16.2737L29.4852 16.178L29.6651 17.7498L31.1818 18.1999L30.8132 19.7385L32.0845 20.6802L31.212 21.9999L32.0845 23.3196L30.8132 24.2613L31.1818 25.7999L29.6651 26.25L29.4852 27.8218L27.906 27.7261L27.1994 29.1416L25.7482 28.5115L24.6 29.5999L23.4518 28.5115L22.0006 29.1416L21.294 27.7261L19.7148 27.8218L19.5349 26.25L18.0182 25.7999L18.3868 24.2613L17.1155 23.3196L17.988 21.9999L17.1155 20.6802L18.3868 19.7385L18.0182 18.1999L19.5349 17.7498L19.7148 16.178L21.294 16.2737L22.0006 14.8582L23.4518 15.4884L24.6 14.3999Z"
          fill="url(#paint0_linear_2527_6693)"
        />
      </g>
      <g filter="url(#filter5_di_2527_6693)">
        <path
          d="M21.4 22.6632L24.1368 25.1998L27.8 18.7998"
          stroke="white"
          strokeOpacity="0.87"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
          shapeRendering="crispEdges"
        />
      </g>
      <defs>
        <filter
          id="filter0_d_2527_6693"
          x="5.46591"
          y="1.27246"
          width="27.3901"
          height="30.9033"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="1" />
          <feGaussianBlur stdDeviation="1.5" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0" />
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_2527_6693" />
          <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_2527_6693" result="shape" />
        </filter>
        <filter
          id="filter1_d_2527_6693"
          x="0.559326"
          y="1.27246"
          width="32.2967"
          height="22.749"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="1" />
          <feGaussianBlur stdDeviation="1.5" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0" />
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_2527_6693" />
          <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_2527_6693" result="shape" />
        </filter>
        <filter
          id="filter2_d_2527_6693"
          x="8.78473"
          y="1.05225"
          width="24.0713"
          height="31.1235"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="1" />
          <feGaussianBlur stdDeviation="1.5" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0" />
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_2527_6693" />
          <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_2527_6693" result="shape" />
        </filter>
        <filter
          id="filter3_d_2527_6693"
          x="9.22546"
          y="1.27246"
          width="23.6306"
          height="31.3965"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="1" />
          <feGaussianBlur stdDeviation="1.5" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0" />
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_2527_6693" />
          <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_2527_6693" result="shape" />
        </filter>
        <filter
          id="filter4_d_2527_6693"
          x="13.1154"
          y="14.3999"
          width="22.9691"
          height="23.2002"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="4" />
          <feGaussianBlur stdDeviation="2" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix type="matrix" values="0 0 0 0 0.0196078 0 0 0 0 0.658824 0 0 0 0 0.00392157 0 0 0 0.21 0" />
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_2527_6693" />
          <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_2527_6693" result="shape" />
        </filter>
        <filter
          id="filter5_di_2527_6693"
          x="16.4"
          y="17.7998"
          width="16.4002"
          height="16.3999"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="4" />
          <feGaussianBlur stdDeviation="2" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0" />
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_2527_6693" />
          <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_2527_6693" result="shape" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dx="0.1" dy="0.1" />
          <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
          <feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.95 0" />
          <feBlend mode="normal" in2="shape" result="effect2_innerShadow_2527_6693" />
        </filter>
        <linearGradient
          id="paint0_linear_2527_6693"
          x1="24.6"
          y1="14.3999"
          x2="24.6"
          y2="29.5999"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#04AF00" />
          <stop offset="1" stopColor="#037D00" />
        </linearGradient>
      </defs>
    </svg>
  )
})

export default MarkPosted
